import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.ContentPromo = class ContentPromo extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-content-promo';
	}
	
	constructor(element) {
		super(element);
	}
	
	render() {
		this.setVars();
		this.setEventListeners();
	}
	
	setVars() {
		this.$anchorableElement = this.$element.find('.fa-content-promo__block-link');
		this.elementHasFocusClass = 'fa-content-promo--has-focus';
	}
	
	setEventListeners() {
		this.$anchorableElement.on('mouseover focus', this.onElementFocusState.bind(this));
		this.$anchorableElement.on('mouseout focusout', this.onElementBlur.bind(this));
	}
	
	onElementFocusState() {
		this.$element.addClass(this.elementHasFocusClass);
	}
	
	onElementBlur(event) {
		const toElement = event.toElement || event.relatedTarget;
		const toElementIsRelated = $.contains(this.$element[0], toElement);
		
		if (!toElementIsRelated) {
			this.$element.removeClass(this.elementHasFocusClass);
		}
	}
};



// WEBPACK FOOTER //
// ./components/contentPromo/scripts/contentPromo.js